import { render, staticRenderFns, recyclableRender, components } from "./current.vue?vue&type=template&id=06de746a&scoped=true&"
var renderjs
import script from "./current.vue?vue&type=script&lang=js&"
export * from "./current.vue?vue&type=script&lang=js&"
import style0 from "./current.vue?vue&type=style&index=0&id=06de746a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de746a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/tabBar/current/current.vue"
export default component.exports